addEventListener('DOMContentLoaded', () => {
	// Opening and closing of FAQ items
	const expandables = document.querySelectorAll('div.faq-block div.faq-expandable')

	if (expandables.length == 0) {
		return
	}

	const toggleExpandable = (expandable) => {
		const details = expandable.querySelector('.details')
		expandable.classList.toggle('open')

		if (expandable.classList.contains('open')) {
			details.style.height = details.scrollHeight + 'px'
		}
		else {
			details.style.height = '0px'
		}
	}

	expandables.forEach((expandable) => {
		const summary = expandable.querySelector('.summary')
		summary?.addEventListener('click', (event) => {
			event.preventDefault()
			toggleExpandable(expandable)
		})
	})

	addEventListener('resize', () => {
		for (let a = 0; a < expandables.length; a++) {
			if (expandables[a].classList.contains('open')) {
				const details = expandables[a].querySelector('.details')
				details.style.height = details.scrollHeight + 'px'
			}
		}
	})

	//
	// Show/hide FAQ's of particular category 
	const categories = document.querySelectorAll('div.faq-block div.faq-categories a')

	const toggleCategories = (category) => {
		const alias = category.dataset.categories

		// Toggle categories.
		for (let a = 0; a < expandables.length; a++) {
			const expandable = expandables[a]
			const aliasses = expandable.dataset.category.split('-')

			const found = aliasses.find(item => item === alias) === alias;
			found ? expandable.classList.remove('hide') : expandable.classList.add('hide')
		}

		// Mark button as active.
		for (let a = 0; a < categories.length; a++) {
			categories[a].classList[categories[a] === category ? 'add' : 'remove']('active')
		}
	}

	for (let i = 0; i < categories.length; i++) {
		categories[i].addEventListener('click', function (event) {
			event.preventDefault()
			toggleCategories(this)
		})
	}
})